var map = {
	"./ban-bg.png": 6990,
	"./bank-image.png": 9994,
	"./banner-01.jpg": 2476,
	"./banner-01.png": 4347,
	"./banner-02.jpg": 9789,
	"./banner-03.jpg": 7395,
	"./banner-04.jpg": 9445,
	"./banner-05.png": 356,
	"./banner.png": 202,
	"./banner_01.png": 845,
	"./banner_02.png": 7935,
	"./become-01.png": 8507,
	"./become-02.png": 6892,
	"./bg-banner-01.png": 6905,
	"./bg-banner-02.png": 6238,
	"./bg-banner.png": 2768,
	"./blog-banner-mata.jpg": 2577,
	"./blog-banner.jpg": 3801,
	"./blur.png": 1418,
	"./categories-icon-01.png": 9922,
	"./categories-icon-02.png": 6826,
	"./categories-icon-03.png": 3864,
	"./categories-icon-04.png": 1610,
	"./categories-icon-05.png": 5130,
	"./categories-icon.png": 6630,
	"./category-bg.png": 4575,
	"./come-soon.png": 2298,
	"./course-01.png": 9581,
	"./course-02.png": 4633,
	"./course-03.png": 3856,
	"./course-04.png": 5079,
	"./course-arrow.png": 1551,
	"./course-bg.png": 2144,
	"./demo.png": 6471,
	"./deposit-01.jpg": 8028,
	"./deposit-01.png": 524,
	"./deposit-02.jpg": 51,
	"./deposit-02.png": 8024,
	"./deposit-03.jpg": 9191,
	"./deposit-03.png": 976,
	"./deposit-04.jpg": 3241,
	"./deposit-04.png": 8069,
	"./deposit.png": 3151,
	"./error-01.png": 7084,
	"./error-02.png": 5927,
	"./error-bg.png": 8736,
	"./error-bg1.png": 6622,
	"./error.png": 9325,
	"./favicon.png": 226,
	"./inner-banner.jpg": 4272,
	"./instructor-profile-bg.jpg": 9002,
	"./intro.png": 5148,
	"./join.png": 2265,
	"./join_01.png": 6713,
	"./join_02.png": 3254,
	"./lead-01.png": 1366,
	"./lead-02.png": 3560,
	"./lead-03.png": 4747,
	"./lead-04.png": 3728,
	"./lead-05.png": 1598,
	"./lead-06.png": 1193,
	"./llama.png": 3193,
	"./login-bg.png": 6685,
	"./login-img.png": 33,
	"./logo.png": 3210,
	"./logo_aicademy.png": 9037,
	"./main_banner.jpg": 7056,
	"./main_banner.png": 2672,
	"./main_banner2.png": 5619,
	"./main_banner4.png": 2114,
	"./main_banner_bg.jpg": 5089,
	"./net-icon-01.png": 3105,
	"./net-icon-02.png": 6678,
	"./net-icon-03.png": 5360,
	"./net-icon-04.png": 1713,
	"./object.png": 607,
	"./plan.png": 9052,
	"./profile-bg.jpg": 7135,
	"./qute-01.png": 4293,
	"./qute.png": 8332,
	"./register-img.png": 7190,
	"./roadmap.png": 4287,
	"./service-01.png": 6563,
	"./service-02.png": 5973,
	"./share.png": 2569,
	"./slide01.jpg": 1031,
	"./slide02.jpg": 6136,
	"./slide03.png": 9627,
	"./slide04.jpg": 8998,
	"./slide05.jpg": 4412,
	"./slide06.jpg": 2062,
	"./spheres.png": 7960,
	"./support-bg.png": 6189,
	"./trend-bg.png": 567,
	"./user-bg-01.png": 4155,
	"./user-bg-02.png": 9590,
	"./user-love.jpg": 4526,
	"./video-bg.jpg": 8034,
	"./video-img-01.jpg": 4216,
	"./video.jpg": 1647,
	"./video1.jpg": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1045;